import styled from '@emotion/styled';
import { COLORS } from '../../constants';

export const StyledAudienceItem = styled.div`
  border: 1px solid ${COLORS.blackOlive};
  border-radius: 5px;
  font-size: 14px;
  font-weight: 600;
  padding: 2px 7px;
  margin-right: 9px;
`;
